<template>
  <Modal
    :name="modalName"
    size="40%"
    :close="true"
    @closeModal="onClose"
  >
    <div class="comments-modal-content p-3 w-100">
      <h2 class="h5 font-weight-bold text-dark mb-3 comments-modal-header">
        {{ $t('lang.label.discussion_with_account_manager') }} {{ client ? ` – ${client.client_name}` : '' }}
      </h2>

      <!-- Cargando -->
      <div v-if="loading" class="d-flex align-items-center justify-content-center py-5">
        <LoadingSpinner />
      </div>
      <template v-else>
        <!-- Lista de comentarios o mensaje vacío -->
        <div v-if="displayComments.length === 0" class="text-muted small mb-4">
          <!-- Aucun commentaire pour le moment. -->
        </div>
        <div v-else class="d-flex flex-column mb-4 flex-fill overflow-auto">
          <div
            v-for="(comment, index) in displayComments"
            :key="index"
            class="p-3 border rounded bg-light shadow-sm mb-3 comment-bubble"
            :class="commentAlignments[index] === 'right' ? 'comment-right' : 'comment-left'"
          >
            <div class="d-flex align-items-center mb-2">
              <div class="mr-2 comments-avatar-wrap">
                <img
                  v-if="comment.avatar"
                  :src="comment.avatar"
                  :alt="comment.author"
                  class="rounded"
                  style="width: 24px; height: 24px; object-fit: cover;"
                >
                <div
                  v-else
                  class="rounded bg-light d-flex align-items-center justify-content-center overflow-hidden"
                  style="width: 24px; height: 24px;"
                >
                  <img
                    src="@/assets/images/comment.png"
                    alt=""
                    class="rounded"
                    style="width: 14px; height: 14px; opacity: 0.7;"
                  >
                </div>
              </div>
              <span class="small text-secondary">
                {{ comment.author }} - {{ comment.date }}
              </span>
            </div>
            <p class="mb-0 text-dark">
              {{ comment.text }}
            </p>
          </div>
        </div>

        <!-- Nuevo mensaje (siempre visible cuando no está cargando) -->
        <div class="modal-footer flex-column align-items-stretch mt-4" style="flex-shrink: 0;">
          <textarea
            v-model="newMessage"
            class="form-control"
            :placeholder="$t('lang.label.publish_message')"
            rows="4"
            style="min-height: 100px; resize: vertical;"
            :disabled="saving"
          />
          <div class="d-flex justify-content-end mt-3">
            <button
              type="button"
              class="btn btn-primary"
              :disabled="!newMessage.trim() || saving"
              @click="onPublish"
            >
              {{ saving ? $t('lang.button.saving')  : $t('lang.label.publish') }}
            </button>
          </div>
        </div>
      </template>
    </div>
  </Modal>
</template>

<script>
import Modal from "./Modal.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

const DEFAULT_MODAL_NAME = "comments-modal";

export default {
  name: "Comments",
  components: {
    Modal,
    LoadingSpinner
  },
  props: {
    modalName: {
      type: String,
      default: DEFAULT_MODAL_NAME
    },
    client: {
      type: Object,
      default: null
    },
    notes: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      newMessage: "",
      saving: false
    };
  },
  computed: {
    displayComments() {
      const list = Array.isArray(this.notes) ? this.notes : [];
      return list.map((n) => ({
        author: n.name + ' ' + n.lastname || "—",
        date: n.created || n.date || "—",
        text: n.message || n.text || "",
        avatar: n.avatar || null
      }));
    },
    commentAlignments() {
      const comments = this.displayComments;
      if (!comments.length) return [];
      const alignments = ["left"];
      for (let i = 1; i < comments.length; i++) {
        if (comments[i].author !== comments[i - 1].author) {
          alignments.push(alignments[i - 1] === "left" ? "right" : "left");
        } else {
          alignments.push(alignments[i - 1]);
        }
      }
      return alignments;
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$modal.show(this.modalName);
      } else {
        this.$modal.hide(this.modalName);
      }
    },
    notes(newVal, oldVal) {
      if (newVal && oldVal && newVal.length > oldVal.length) {
        this.newMessage = "";
        if (this.saving) this.saving = false;
      }
    }
  },
  methods: {
    onClose() {
      this.newMessage = "";
      this.$emit("close");
    },
    onPublish() {
      this.saving = true;
      this.$emit("publish", this.newMessage);
    }
  }
};
</script>

<style scoped>
/* Contenedor del modal: altura limitada al viewport para permitir scroll */
.comments-modal-content {
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}

.comments-modal-header {
  flex-shrink: 0;
}

/* Bootstrap 4 no tiene flex-shrink-0; necesario para que el avatar no se comprima */
.comments-avatar-wrap {
  flex-shrink: 0;
}

/* Burbujas de comentarios: alternan izquierda/derecha según cambio de autor */
.comment-bubble {
  max-width: 85%;
}
.comment-left {
  align-self: flex-start;
}
.comment-right {
  align-self: flex-end;
}
</style>
